export const datapoints = {
    AttFolderPickerOpened: {
        datapoint: {
            name: 'AttFolderPickerOpened',
        },
    },
    AttFolderPickerDismissed: {
        datapoint: {
            name: 'AttFolderPickerDismissed',
        },
    },
    AttFolderPickerChangeLocation: {
        datapoint: {
            name: 'AttFolderPickerChangeLocation',
        },
    },
    AttFolderPickerUpload: {
        datapoint: {
            name: 'AttFolderPickerUpload',
        },
    },
};
